/* eslint-disable react/jsx-props-no-spreading */

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button as BsButton } from 'reactstrap';

const Button = ({ children, disabled, kind, size, color, className, ...rest }) => {
  return (
    <BsButton
      disabled={disabled}
      className={classNames('button', size, color, kind, ...className.split(' '))}
      {...rest}
    >
      {children}
    </BsButton>
  );
};

Button.propTypes = {
  kind: PropTypes.oneOf(['flat', 'outline', 'text']),
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'xs', 'xs1']),
  color: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Button.defaultProps = {
  kind: 'flat',
  size: 'lg',
  color: 'primary',
  children: '',
  disabled: false,
  className: '',
};

export default Button;
